module.exports = __webpack_public_path__ + "img/icon_withdraw@2x.a83d7bd2.png";